<template>
  <div class="flex flex-col min-h-[100vh]">
    <p-d-navigation />
    <div class="relative overflow-hidden grow-1 flex items-stretch">
      <slot />
    </div>

  </div>
</template>